import { TOUR_BASE_QUERY_KEY } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import { PLANNED_TRANSACTIONS_BASE_KEY } from '@/features/dashboard/plannedTransactions/api/plannedTransactionsApi.queryKeys.ts';

export const tourPlannedTransactionsApiQueryKeys = {
  byTour: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, PLANNED_TRANSACTIONS_BASE_KEY] as const,
};
